export default {output:'çıktı'};